import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    // marginTop: '-36px',
  },
  widgetLayout: {
    margin: '0 0 32px 0',
  },
  loaderWidgetLayout: {
    marginTop: '32px',
  },
  autoloadWidgetLayout: {
    margin: 0,
  },
}));
